import { db } from './../config/Fire';
import * as Constants from './../constants/nodes_database';

export const SET_RESTAURANT_USER = 'SET_RESTAURANT_USER';
export const LOADING_RESTAURANT = 'LOADING_RESTAURANT';
export const ERROR_RESTAURANT = 'ERROR_RESTAURANT';

const setRestaurantUser = payload => ({ type: SET_RESTAURANT_USER, payload });
const setLoadingRestaurant = payload => ({ type: LOADING_RESTAURANT, payload });
export const setErrorRestaurant = payload => ({ type: ERROR_RESTAURANT, payload });

export const setRestaurantById = payload => {
    return dispatch => {
        var isLoadingRestaurant = true;
        dispatch(setLoadingRestaurant(isLoadingRestaurant));
        return db.ref(`${Constants.RESTAURANTS}/${payload}`).on('value', function(snapshot) {
            if(snapshot.exists() && snapshot.val() !== null) {
                var restaurant = snapshot.val();
                //console.log("getRestaurant: " + JSON.stringify(restaurant));
                dispatch(setErrorRestaurant({ state: false, rason: ""}));
                dispatch(setLoadingRestaurant(isLoadingRestaurant = false));
                dispatch(setRestaurantUser(restaurant));
            } else {
                console.log("getRestaurant not found: " + null);
                dispatch(setErrorRestaurant({ state: true, rason: "RESTO_NOT_FOUND"}));
                dispatch(setLoadingRestaurant(isLoadingRestaurant= false));
                dispatch(setRestaurantUser(null));
            }
        });
    };
};